import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner";
import { InfoIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { LessonInfoBanner_booking$key } from "./__generated__/LessonInfoBanner_booking.graphql";

type Props = {
  bookingRef: LessonInfoBanner_booking$key | null;
};

export const LessonInfoBanner = ({ bookingRef }: Props) => {
  const data = useFragment(LessonInfoBannerFragment, bookingRef);

  if (data?.__typename !== "LessonBooking" || !data.lessonType?.description) {
    return null;
  }

  return (
    <Box marginTop={2}>
      <InfoBanner
        leadingIcon={InfoIcon}
        message={data.lessonType?.description ?? ""}
        colorTheme="NEUTRAL"
        testID="lesson-info-banner"
      />
    </Box>
  );
};

export const LessonInfoBannerFragment = graphql`
  fragment LessonInfoBanner_booking on Booking {
    __typename
    ... on LessonBooking {
      lessonType {
        description
      }
    }
  }
`;
